<template>
  <Card variant="primary" size="large" class="table" :style="{ '--table-columns': columns }">
    <div class="table-header" aria-hidden="true">
      <Text v-for="(header, index) in headers" :key="index" as="span" variant="label-small" color="secondary">
        {{ header }}
      </Text>
    </div>

    <div class="rows">
      <slot />
    </div>
  </Card>
</template>

<script setup lang="ts">
import Card from '../card/card.vue';
import Text from '../text.vue';

/**
 * A list as rows under a header, the properties page's table view. `columns` is the grid template
 * every row follows; `headers` names them, an empty string leaving a column unnamed.
 */
defineProps<{ columns: string; headers: string[] }>();
</script>

<style scoped lang="scss">
// The rows carry their own padding, so the card gives up its own: with it, their hairlines and hover
// would stop short of the edges. Named down to the size, to outrank the card's own size rule
.table.card.large {
  padding: 0;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: var(--table-columns);
  gap: var(--t-spacing-md);
  padding: var(--t-spacing-md) var(--t-spacing-lg);
}

.rows {
  display: flex;
  flex-direction: column;
}
</style>
